import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';
import {
  setPropertyWalkThroughFormData,
  exitPropertyWalkThroughForm,
  setPropertyWalkThroughFormNextStep,
} from 'src/store/actions/propertyWalkThroughForm';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { selectPropertyWalkThroughFormData } from 'src/store/selectors/propertyWalkThroughForm';
import moment from 'moment';
import { clearAssetFormData } from 'src/store/actions/assetForm';
import { fetchItems } from 'src/store/actions/items';
import {
  saveAssetConfig,
  saveSubAreaDescription,
  fetchAreaData,
  saveAreaDescription,
  changeSequenceAreaOrder,
} from 'src/store/actions/areas';
import { upload } from 'src/helpers/upLoadHelper';
import Loader from '../../components/Loader';
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
} from 'src/store/actions/easyWalkThroughForm';
import { setWalkThroughStatus } from 'src/store/actions/suites';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import { fetchSuiteWalkThroughs } from 'src/store/actions/walkThroughs';
import AddAssetDialog from 'src/components/AddAssetDialogue/AddAssetDialogue';
import 'react-toastify/dist/ReactToastify.css';
import './propertyWalkThroughForm.scss';

const ConfigureSubArea = () => {
  const dispatch = useDispatch();

  const propertyWalkThroughFormData: any = useSelector((state: any) =>
    selectPropertyWalkThroughFormData(state)
  );
  const user: any = useSelector((state: any) => selectAuthenticatedUser(state));
  const areas: any = useSelector((state: any) => state.areas);
  const loader: any = useSelector((state: any) => selectFormLoader(state));

  const onSetPropertyWalkThroughFormData = (data: any) =>
    dispatch(setPropertyWalkThroughFormData(data));
  const onSetPropertyWalkThroughFormNextStep = () =>
    dispatch(setPropertyWalkThroughFormNextStep());
  const onExitPropertyWalkThroughForm = () =>
    dispatch(exitPropertyWalkThroughForm());
  const onClearAssetFormData = () => dispatch(clearAssetFormData());
  const onSaveAsset = (params: any, walkthroughId: any) =>
    dispatch(saveAssetConfig(params, walkthroughId));
  const onFetchItems = () => dispatch(fetchItems());
  const onSaveSubAreaDescription = (params: any, walkthroughId: any) =>
    dispatch(saveSubAreaDescription(params, walkthroughId));
  const onFetchAreaData = (walkthroughId: any, areaId: any) =>
    dispatch(fetchAreaData(walkthroughId, areaId));
  const onSaveAreaDescription = (params: any, walkthroughId: any) =>
    dispatch(saveAreaDescription(params, walkthroughId));
  const onSetEasyWalkThroughFormData = (data: any) =>
    dispatch(setEasyWalkThroughFormData(data));
  const onSetWalkThroughStatus = (params: any) =>
    dispatch(setWalkThroughStatus(params));
  const onExitEasyWalkThroughForm = () => dispatch(exitEasyWalkThroughForm());
  const onChangeSequenceAreaOrder = (data: any, walkthroughId: any) =>
    dispatch(changeSequenceAreaOrder(data, walkthroughId));
  const onFetchSuiteWalkThroughs = (suiteId: any, roleName: any) =>
    dispatch(fetchSuiteWalkThroughs(suiteId, roleName));

  const [showOverlay, setShowOverlay] = useState(false);
  const [sequence, setSequence] = useState<any>({});

  useEffect(() => {
    onFetchItems();
    if (areas.length > 0) {
      if (!propertyWalkThroughFormData.selectedAreaId) {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      } else {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prevAreasRef = React.useRef(areas);

  useEffect(() => {
    if (prevAreasRef.current !== areas) {
      if (!propertyWalkThroughFormData.selectedAreaId) {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      }
    }
    prevAreasRef.current = areas;
  }, [areas]);

  const handleSaveAsset = (asset: any) => {
    const { suiteId, configTypeSaved } = propertyWalkThroughFormData;

    let params: any = {
      UnitId: suiteId,
      ItemId: asset.itemId,
      RoomType: asset.roomType,
      UserId: user.id,
      Name: asset.item.name,
      Description: '',
      WalkthroughId: configTypeSaved.id,
      AreaId: asset.areaId,
      DateOfPurchase: asset.dateOfPurchase
        ? new Date(moment(asset.dateOfPurchase).format('l LT'))
        : null,
      VendorId: asset && asset.vendorId ? asset.vendorId : null,
      VendorName: asset && asset.vendorId ? asset.vendorName : '',
    };

    if (!asset.vendorId) {
      delete params.VendorId;
      delete params.VendorName;
    }

    onSaveAsset(params, propertyWalkThroughFormData.walkthroughId);
  };

  const uploadimg = async (imgFile: any, callback: any) => {
    let imageUrl = await upload(imgFile);
    let object = {
      Name: imageUrl.split('.com/')[1],
      URL: imageUrl,
    };

    callback(object);
  };

  const handleMultipleUpload = async (subAreaMedia: any, callback: any) => {
    let uploadImages: any[] = [];
    for (let i = 0; i < subAreaMedia.length; i++) {
      if (subAreaMedia[i] && subAreaMedia[i].id) {
        uploadImages.push(subAreaMedia[i]);
      } else {
        await uploadimg(subAreaMedia[i], (imgData: any) => {
          uploadImages.push(imgData);
        });
      }
    }

    callback(uploadImages);
  };

  const onSaveSubArea = async () => {
    let {
      suiteId,
      subAreaName,
      subAreaDescription,
      selectedAreaId,
      walkThroughMedia,
      deletedFiles,
      checkList,
      checkListValue,
    } = propertyWalkThroughFormData;

    if (propertyWalkThroughFormData.edited === true) {
      onSetPropertyWalkThroughFormData({ edited: false });

      if (checkListValue !== '') {
        if (checkList && checkList.length > 0) {
          checkList = [
            ...checkList,
            { description: propertyWalkThroughFormData.checkListValue },
          ];
        } else {
          checkList = [
            {
              description: propertyWalkThroughFormData.checkListValue,
            },
          ];
        }
      }
      onSetPropertyWalkThroughFormData({ checkListValue: '' });

      if (
        propertyWalkThroughFormData.deletedCheckList &&
        propertyWalkThroughFormData.deletedCheckList.length > 0
      ) {
        checkList = [
          ...checkList,
          ...propertyWalkThroughFormData.deletedCheckList,
        ];
      }
      onSetPropertyWalkThroughFormData({ checkList });

      onSetPropertyWalkThroughFormData({ edited: false });

      let faqs =
        propertyWalkThroughFormData.walkthroughFAQDetails &&
        propertyWalkThroughFormData.walkthroughFAQDetails.length > 0
          ? propertyWalkThroughFormData.walkthroughFAQDetails.map((f: any) => {
              if (f.id) {
                if (f.isDeleted === true) {
                  return {
                    id: f.id,
                    questionId: f.questionId,
                    isDeleted: true,
                  };
                } else {
                  if (f.id && f.questionId) {
                    return { id: f.id, questionId: f.questionId };
                  }
                  return { questionId: f.id };
                }
              }
            })
          : [];

      let params: any = {
        id: propertyWalkThroughFormData.subAreaId,
        UnitId: suiteId,
        Name: subAreaName,
        Description: subAreaDescription,
        walkthroughId: propertyWalkThroughFormData.walkthroughId,
        AreaId: selectedAreaId,
        userId: user.id,
        walkThroughMedia: [],
        WalkthroughChecklistItems: checkList,
        WalkthroughFAQDetails: faqs,
      };

      if (propertyWalkThroughFormData.type !== 'Area') {
        params.assetId = propertyWalkThroughFormData.assetId;
      }

      if (walkThroughMedia && walkThroughMedia.length > 0) {
        await handleMultipleUpload(walkThroughMedia, function (resObj: any) {
          let files =
            propertyWalkThroughFormData.deletedFiles &&
            propertyWalkThroughFormData.deletedFiles.length > 0
              ? [...resObj, ...propertyWalkThroughFormData.deletedFiles]
              : resObj;

          params.walkThroughMedia = files;
          if (propertyWalkThroughFormData.type === 'Area') {
            onSaveAreaDescription(
              params,
              propertyWalkThroughFormData.walkthroughId
            );
          } else {
            onSaveSubAreaDescription(
              params,
              propertyWalkThroughFormData.walkthroughId
            );
          }
        });
      } else {
        if (deletedFiles && deletedFiles.length > 0) {
          params.walkThroughMedia = deletedFiles;
        }
        if (propertyWalkThroughFormData.type === 'Area') {
          onSaveAreaDescription(
            params,
            propertyWalkThroughFormData.walkthroughId
          );
        } else {
          onSaveSubAreaDescription(
            params,
            propertyWalkThroughFormData.walkthroughId
          );
        }
      }
    }
  };

  const handleNext = () => {
    const { selectedAreaId, walkthroughId } = propertyWalkThroughFormData;
    if (
      propertyWalkThroughFormData.edited &&
      propertyWalkThroughFormData.edited === true
    ) {
      alert(
        'Please Click Save Area/Sub area Button at bottom to save the changes made to area/sub area '
      );
    } else {
      onSetPropertyWalkThroughFormData({ edited: false });

      let params = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        status: 'Activate',
      };
      if (
        propertyWalkThroughFormData.walkthroughType === 'Enhanced' &&
        propertyWalkThroughFormData.permissions === 'Internal'
      ) {
        params.status = 'Begin';
      }
      onSetWalkThroughStatus(params);
      onFetchAreaData(walkthroughId, selectedAreaId);

      onSetPropertyWalkThroughFormData({
        description: '',
        question: '',
        subAreaDescription: '',
        walkThroughMedia: [],
        checkList: [],
      });

      onSetPropertyWalkThroughFormNextStep();
    }
  };

  const handleAddCheckList = () => {
    let checkList = propertyWalkThroughFormData.checkList
      ? propertyWalkThroughFormData.checkList
      : [];
    if (propertyWalkThroughFormData.checkListValue.trim().length > 0) {
      checkList = [
        ...checkList,
        { description: propertyWalkThroughFormData.checkListValue },
      ];
      onSetPropertyWalkThroughFormData({
        checkList: checkList,
        checkListValue: '',
        edited: true,
      });
    } else {
      onSetPropertyWalkThroughFormData({ checkListValue: '' });
    }
  };

  const handleDeleteCheckList = (item: any, i: any) => {
    let deletedCheckList =
      propertyWalkThroughFormData.deletedCheckList &&
      propertyWalkThroughFormData.deletedCheckList.length > 0
        ? propertyWalkThroughFormData.deletedCheckList
        : [];
    if (item.id) {
      item = { ...item, isDeleted: true };
      deletedCheckList = [item, ...deletedCheckList];
    }
    let checkList = propertyWalkThroughFormData.checkList;
    if (item.id) {
      checkList = checkList.filter((i: any) => i.id !== item.id);
    } else {
      checkList = checkList.filter((data: any, index: any) => index !== i);
    }

    onSetPropertyWalkThroughFormData({
      checkList,
      deletedCheckList,
      edited: true,
    });
  };

  const handleEditCheckList = (e: any, item: any, i: any) => {
    let checkList = propertyWalkThroughFormData.checkList;
    checkList = checkList.map((data: any, j: any) => {
      if (i === j) {
        item = { ...item, description: e.target.value };
        return item;
      } else {
        return data;
      }
    });
    onSetPropertyWalkThroughFormData({ checkList, edited: true });
  };

  const onDropSequence = (areaData: any, i: any) => {
    let data = {
      SequenceList: [
        {
          id: sequence.id,
          Sequence: areaData.sequence,
          UserId: sequence.userId,
        },
        {
          id: areaData.id,
          Sequence: sequence.sequence,
          UserId: areaData.userId,
        },
      ],
    };

    onChangeSequenceAreaOrder(data, propertyWalkThroughFormData.walkthroughId);
    setSequence({});
  };

  const { propertyName, suiteName, walkthroughId } =
    propertyWalkThroughFormData;

  const roleName = user.roles[0].role.name;

  return (
    <>
      {loader === true ? <Loader center={true} /> : null}
      <div className="header_section">
        <div className="header_box">
          <div className="header_back_btn">
            <div
              className="back_arrow"
              onClick={() => {
                onFetchSuiteWalkThroughs(
                  propertyWalkThroughFormData.suiteId,
                  roleName
                );
                onExitPropertyWalkThroughForm();
                onExitEasyWalkThroughForm();
              }}
            >
              <a href="#.">
                <svg
                  width="21"
                  height="18"
                  viewBox="0 0 21 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="configure_heading">
            <h2>Configure Walk Through</h2>
          </div>
          <div className="next_btn text-right" onClick={() => handleNext()}>
            <a
              href="#."
              style={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid whitesmoke',
                borderRadius: '5px',
              }}
            >
              Save Walk Through
            </a>
          </div>
        </div>
      </div>
      <div
        className="avenue_section bedroom_list_section WalkthroughScroll"
        style={{ width: '92%' }}
      >
        <div className="avenue_main_box">
          <div className="avenue_heading">
            <h4>{propertyName + ', ' + suiteName}</h4>
          </div>
          <div className="bedroom_list_box">
            <div className="bedroom_main_section">
              <div className="bedroom_section">
                {areas.map((area: any, i: any) => (
                  <div
                    className={
                      propertyWalkThroughFormData.selectedArea === area.name
                        ? 'bedroom_main_box1 order_active'
                        : 'bedroom_main_box1 order_inactive'
                    }
                    onClick={() => {
                      onSetEasyWalkThroughFormData({ areaId: area.areaId });
                      onSetPropertyWalkThroughFormData({
                        selectedArea: area.name,
                        subAreaId: area.id,
                        type: 'Area',
                        selectedAreaId: area.areaId,
                        subAreaName: area.customLabel
                          ? area.customLabel
                          : area.name,
                        checkListValue: '',
                        question: '',
                        answer: '',
                        showSubArea: false,
                        deletedCheckList: [],
                        edited: false,
                      });
                      onFetchAreaData(walkthroughId, area.areaId);
                    }}
                  >
                    <div
                      className={
                        propertyWalkThroughFormData.selectedArea === area.name
                          ? 'bedroom_heading active text_elipse'
                          : 'bedroom_heading text_elipse'
                      }
                      style={{
                        cursor: 'pointer',
                        padding: 10,
                        width: 'auto',
                      }}
                      draggable
                      onDragStart={() => {
                        setSequence({ ...area, order: area.sequence });
                      }}
                      onDrop={() => {
                        onDropSequence(area, i);
                      }}
                      onDragOver={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <div className="bed_icon">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1001 5.53747C16.9243 5.71303 16.686 5.81164 16.4376 5.81164C16.1891 5.81164 15.9508 5.71303 15.7751 5.53747L13.9376 3.69997V8.31247C13.9376 8.56111 13.8388 8.79957 13.663 8.97538C13.4872 9.1512 13.2487 9.24997 13.0001 9.24997C12.7514 9.24997 12.513 9.1512 12.3371 8.97538C12.1613 8.79957 12.0626 8.56111 12.0626 8.31247V3.69997L10.2251 5.53747C10.0473 5.70307 9.81228 5.79322 9.5694 5.78894C9.32652 5.78465 9.09479 5.68626 8.92303 5.5145C8.75126 5.34273 8.65287 5.111 8.64858 4.86812C8.6443 4.62525 8.73445 4.39019 8.90005 4.21247L12.3376 0.774969C12.5133 0.599405 12.7516 0.500793 13.0001 0.500793C13.2485 0.500793 13.4868 0.599405 13.6626 0.774969L17.1001 4.21247C17.2756 4.38825 17.3742 4.62653 17.3742 4.87497C17.3742 5.12341 17.2756 5.36169 17.1001 5.53747Z"
                            fill="#8E8E8E"
                          />
                          <path
                            d="M5.53741 15.775C5.62952 15.8608 5.70339 15.9643 5.75463 16.0793C5.80587 16.1943 5.83343 16.3185 5.83565 16.4443C5.83787 16.5702 5.81471 16.6953 5.76756 16.812C5.72041 16.9287 5.65023 17.0348 5.56121 17.1238C5.47218 17.2128 5.36614 17.283 5.2494 17.3301C5.13267 17.3773 5.00763 17.4004 4.88175 17.3982C4.75588 17.396 4.63173 17.3685 4.51674 17.3172C4.40174 17.266 4.29823 17.1921 4.21241 17.1L0.774908 13.6625C0.599344 13.4867 0.500732 13.2484 0.500732 13C0.500732 12.7516 0.599344 12.5133 0.774908 12.3375L4.21241 8.89999C4.39013 8.73439 4.62518 8.64424 4.86806 8.64852C5.11094 8.65281 5.34267 8.7512 5.51443 8.92296C5.6862 9.09473 5.78459 9.32646 5.78888 9.56934C5.79316 9.81222 5.70301 10.0473 5.53741 10.225L3.69991 12.0625H8.31241C8.56105 12.0625 8.7995 12.1613 8.97532 12.3371C9.15114 12.5129 9.24991 12.7513 9.24991 13C9.24991 13.2486 9.15114 13.4871 8.97532 13.6629C8.7995 13.8387 8.56105 13.9375 8.31241 13.9375H3.69991L5.53741 15.775Z"
                            fill="#8E8E8E"
                          />
                          <path
                            d="M20.4625 17.1C20.2869 16.9242 20.1883 16.6859 20.1883 16.4375C20.1883 16.1891 20.2869 15.9508 20.4625 15.775L22.3 13.9375H17.6875C17.4389 13.9375 17.2004 13.8387 17.0246 13.6629C16.8488 13.4871 16.75 13.2486 16.75 13C16.75 12.7514 16.8488 12.5129 17.0246 12.3371C17.2004 12.1613 17.4389 12.0625 17.6875 12.0625H22.3L20.4625 10.225C20.2969 10.0473 20.2067 9.81222 20.211 9.56934C20.2153 9.32646 20.3137 9.09473 20.4855 8.92296C20.6572 8.7512 20.889 8.65281 21.1318 8.64852C21.3747 8.64424 21.6098 8.73439 21.7875 8.89999L25.225 12.3375C25.4006 12.5133 25.4992 12.7516 25.4992 13C25.4992 13.2484 25.4006 13.4867 25.225 13.6625L21.7875 17.1C21.6117 17.2756 21.3734 17.3742 21.125 17.3742C20.8766 17.3742 20.6383 17.2756 20.4625 17.1Z"
                            fill="#8E8E8E"
                          />
                          <path
                            d="M17.1001 20.4625C16.9243 20.2869 16.686 20.1883 16.4376 20.1883C16.1891 20.1883 15.9508 20.2869 15.7751 20.4625L13.9376 22.3V17.6875C13.9376 17.4389 13.8388 17.2004 13.663 17.0246C13.4872 16.8488 13.2487 16.75 13.0001 16.75C12.7514 16.75 12.513 16.8488 12.3371 17.0246C12.1613 17.2004 12.0626 17.4389 12.0626 17.6875V22.3L10.2251 20.4625C10.0473 20.2969 9.81228 20.2067 9.5694 20.211C9.32652 20.2153 9.09479 20.3137 8.92303 20.4855C8.75126 20.6572 8.65287 20.889 8.64858 21.1318C8.6443 21.3747 8.73445 21.6098 8.90005 21.7875L12.3376 25.225C12.5133 25.4006 12.7516 25.4992 13.0001 25.4992C13.2485 25.4992 13.4868 25.4006 13.6626 25.225L17.1001 21.7875C17.2756 21.6117 17.3742 21.3734 17.3742 21.125C17.3742 20.8766 17.2756 20.6383 17.1001 20.4625Z"
                            fill="#8E8E8E"
                          />
                        </svg>
                      </div>
                      <h3
                        className="title_elipse"
                        style={{
                          color:
                            propertyWalkThroughFormData.selectedArea ===
                              area.name && '#fff',
                        }}
                      >
                        {area.customLabel ? area.customLabel : area.name}
                      </h3>
                    </div>
                  </div>
                ))}
              </div>
              <div className="bedroom_right_section">
                <div className="bedroom_list_item_box">
                  <div className="area_heading">
                    <h4>Area :</h4>
                    <label style={{ padding: '0px' }}>
                      {propertyWalkThroughFormData.subAreaName}
                    </label>
                  </div>
                </div>
                <div className="bedroom_list_item_box">
                  <div className="area_heading">
                    <h4>Check List :</h4>
                    {propertyWalkThroughFormData.checkList &&
                    propertyWalkThroughFormData.checkList.length > 0
                      ? propertyWalkThroughFormData.checkList.map(
                          (item: any, i: any) =>
                            item.isDeleted !== true ? (
                              <div className="mainDiv">
                                <div className="w-93">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={item.description}
                                    onChange={(e) =>
                                      handleEditCheckList(e, item, i)
                                    }
                                    aria-label="default input example"
                                  ></input>
                                </div>
                                <div className="w-7">
                                  <a
                                    className="closeBtn"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      handleDeleteCheckList(item, i)
                                    }
                                  >
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.258279 0.580619C0.404791 0.434106 0.603506 0.351796 0.810706 0.351796C1.01791 0.351796 1.21662 0.434106 1.36313 0.580619L4.67769 3.89518L7.99225 0.580619C8.13876 0.434106 8.33748 0.351796 8.54468 0.351796C8.75188 0.351796 8.95059 0.434106 9.0971 0.580619C9.24361 0.727132 9.32592 0.925845 9.32593 1.13305C9.32593 1.34025 9.24361 1.53896 9.0971 1.68547L5.78254 5.00003L9.0971 8.31459C9.24361 8.4611 9.32593 8.65982 9.32593 8.86702C9.32592 9.07422 9.24361 9.27293 9.0971 9.41944C8.95059 9.56595 8.75188 9.64826 8.54468 9.64827C8.33748 9.64826 8.13876 9.56595 7.99225 9.41944L4.67769 6.10488L1.36313 9.41944C1.21662 9.56595 1.01791 9.64827 0.810706 9.64826C0.603506 9.64826 0.404791 9.56595 0.258279 9.41944C0.111766 9.27293 0.0294564 9.07422 0.0294564 8.86702C0.0294565 8.65982 0.111766 8.4611 0.258279 8.31459L3.57284 5.00003L0.258279 1.68547C0.111766 1.53896 0.0294565 1.34025 0.0294564 1.13305C0.0294564 0.925845 0.111766 0.727132 0.258279 0.580619Z"
                                        fill="black"
                                      ></path>
                                    </svg>
                                  </a>
                                </div>
                              </div>
                            ) : null
                        )
                      : null}
                    <div className="mainDiv">
                      <div className="">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Checklist"
                          value={propertyWalkThroughFormData.checkListValue}
                          onChange={(e) =>
                            onSetPropertyWalkThroughFormData({
                              checkListValue: e.target.value,
                              edited: true,
                            })
                          }
                          aria-label="default input example"
                        ></input>
                      </div>

                      <div className="">
                        <button
                          className="btnchecklist"
                          onClick={() => handleAddCheckList()}
                        >
                          + Add New Row
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="next_btn text-right"
                  onClick={() => onSaveSubArea()}
                >
                  <a href="#">Save</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddAssetDialog
        isOpen={showOverlay}
        onClose={() => {
          setShowOverlay(false);
          onClearAssetFormData();
        }}
        onSaveAsset={(data: any) => handleSaveAsset(data)}
        newAsset={true}
        propertyId={propertyWalkThroughFormData.suiteId}
        selectedAreaId={propertyWalkThroughFormData.selectedAreaId}
      />
    </>
  );
};

export default ConfigureSubArea;
